import React, { useState, useEffect } from "react";
import DataServiceSQL from "../../DataService/DataServiceSQL";
import { Row, Col } from 'reactstrap';
import { withStyles } from '@material-ui/core';
import * as Constants from '../../Pages/Constants';
import InvalidObject from '../Common/InvalidObject.js';
import {FormattedMessage} from 'react-intl';

const AddGroup = (props) => {
  const [group, setGroup] = useState({group_name: "", description: ""});
  const [submitted, setsubmitted] = useState(false);
  const [message, setmessage] = useState("");
  const [wrongEntryPopup, setWrongEntryPopup] = useState(false);

  useEffect(() => {
  }, []);

  //Function to handle values of different fields of the popup
  const handleInputChange = event => {
    const { name, value } = event.target;
    setGroup({ ...group, [name]: value });
  };
  

  //Function to create groupe in case of good entry
  const saveGroup = () => {
    var data = {
      resourceType: "Group",
      name: group.group_name,
      description: group.description
    };    

    if(data.group_name === ""){
      setmessage("Please fill at least group name to create a new group");
      manageWrongEntryPopupDisplay();
    }
    else{
      DataServiceSQL.createGroupReq_fhir(data)
        .then(response => {
          props.reloadGroups();
          setmessage(<FormattedMessage id="message.success" defaultMessage="Success !" />);
          setsubmitted(true);

        })
        .catch(e => {
          setmessage(<FormattedMessage id="message.error.addgrp" defaultMessage="Oups, did not work... (err_code addgrp)" />);
          setsubmitted(true);
        });
    }
  };

  //Function to manage wrong entry popup display
  const manageWrongEntryPopupDisplay = () => {
      setWrongEntryPopup(!wrongEntryPopup);
  }

  const { classes } = props;

  return (
    <div className={classes.popup_background}>
      <div style={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "center"}}>
        <div className="submit-form">
          {submitted ? (
            <div>
              <center>
                <h4>{message}</h4>
                <button onClick={props.closeAfterAdd} className="btn btn-success">
                  <FormattedMessage id="button.close" defaultMessage="Close" />
                </button>
              </center>
            </div>
          ) : (
            <div>
              <center>
                <div>
                  <Row className="justify-content-md-end">
                    <Col style={{ fontWeight: "bold", fontSize:"2.2em" }}>
                      <FormattedMessage id="group.add" defaultMessage="Add group" />
                    </Col>
                  </Row>
                </div>
                <br/>                              
                <div className="form-group" style={{paddingTop:"5%"}}>
                  <label htmlFor="group_name">
                      <FormattedMessage id="group.name" defaultMessage="Name" />
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="group_name"
                    required
                    defaultValue={group.group_name}
                    onChange={handleInputChange}
                    name="group_name"
                  />
                </div>
                <div className="form-group" style={{paddingTop:"5%"}}>
                  <label htmlFor="description">
                    <FormattedMessage id="group.description" defaultMessage="Description" />
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="description"
                    required
                    defaultValue={group.description}
                    onChange={handleInputChange}
                    name="description"
                  />
                </div>
                <br/>          
                <b>&emsp;</b>
                <button onClick={props.cancelPopup} className="btn btn-danger">
                  <FormattedMessage id="button.cancel" defaultMessage="Cancel" />
                </button>
                <b>&emsp;</b>
                <button onClick={saveGroup} className="btn btn-success">
                  <FormattedMessage id="button.submit" defaultMessage="Submit" />
                </button>
              </center>
            </div>
          )}
        </div>
      </div>
      {wrongEntryPopup ?
        <InvalidObject message={message} cancelPopup={manageWrongEntryPopupDisplay}/>
        :
        null
      }
    </div>
  );
};

export default withStyles(Constants.styles)(AddGroup);
